import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
            <i className="ri-book-open-line text-background-50 text-lg"></i>
          </div>
          <span className="text-xl font-heading text-foreground-950 font-bold">
            51漫画网
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link
            to="/"
            className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap"
          >
            首页
          </Link>
          <Link
            to="/category/hot-blood"
            className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap"
          >
            分类
          </Link>
          <Link
            to="/category/all?sort=popular"
            className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap"
          >
            排行榜
          </Link>
          <Link
            to="/about"
            className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap"
          >
            关于我们
          </Link>
        </div>

        <div className="hidden md:flex items-center gap-3">
          <button className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-background-200 transition-colors cursor-pointer">
            <i className="ri-search-line text-foreground-600 text-base"></i>
          </button>
          <Link
            to="/category/all"
            className="px-5 py-2 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            开始阅读
          </Link>
        </div>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-foreground-700 text-lg`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4 flex flex-col gap-3">
          <Link to="/" className="text-sm font-medium text-foreground-700 py-2" onClick={() => setMobileOpen(false)}>首页</Link>
          <Link to="/category/hot-blood" className="text-sm font-medium text-foreground-700 py-2" onClick={() => setMobileOpen(false)}>分类</Link>
          <Link to="/category/all?sort=popular" className="text-sm font-medium text-foreground-700 py-2" onClick={() => setMobileOpen(false)}>排行榜</Link>
          <Link to="/about" className="text-sm font-medium text-foreground-700 py-2" onClick={() => setMobileOpen(false)}>关于我们</Link>
          <Link to="/category/all" className="mt-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold text-center whitespace-nowrap cursor-pointer" onClick={() => setMobileOpen(false)}>开始阅读</Link>
        </div>
      )}
    </nav>
  );
}